import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../_helpers/dataservice.service'
import { CustomerService } from '../_services/customer.service'
import { DebtorService } from '../_services/debtor.service'
import { Invoice, PaymentProcess, Debtor, InvoiceList, Account } from '../_models';
import { AppConfig } from '../_helpers/index';
import { PaymentProcessService } from '../_services/paymentprocess.service';
import { AuthService } from '../_services/auth.service';
import * as moment from 'moment';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';




@Component({
    selector: 'paymentcreate',
    templateUrl: './paymentcreate.component.html',
    styleUrls: ['../../assets/css/customer-list-table.css'],

})



export class PaymentCreateComponent implements OnInit {

    public customer_public_id: string;
    public customer_account_public_id: string;
    public user_id: string;
    public CreatedDate: string;
    public paymentprocessForm: FormGroup;
    public cusPsp_accountsList: Account[] = [];
    public cusPsp_accountsListNew: Account[] = [];
    public cusDebtor_accountsList: Account[] = [];
    public cusDebtorList: Debtor[] = [];
    public invoicelist_temp: InvoiceList[] = [];
    public selectinvoicelist: Invoice[] = [];
    auth0Profile: any;
    invoiceTotalAmt: number = 0;
    displayedColumns: string[] = ['select', 'created', 'name', 'total.value', 'status'];
    dataSourceInvoicesList = new MatTableDataSource();
    selection = new SelectionModel<Invoice>(true, []);
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    statusValue: any;
    created: any;
    currencysymbol: any;
    isalertVisiable: boolean;
    order: any = "name";
    ascending: any = true;
    public user_public_id: string;
    offsetTimeZone: any;
    offsetMinutes: any;
    offsetTimeVal: any;

    public buttonValidate = false;

    constructor
        (
            private router: Router
            , private formBuilder: FormBuilder
            , private parameterData: ParameterData
            , private dataService: DataService
            , private invoicesService: InvoicesService
            , private readonly activatedRoute: ActivatedRoute
            , private paymentProcessService: PaymentProcessService
            , private _fbpayprocess: FormBuilder
            , private customerService: CustomerService
            , private debtorService: DebtorService
            , private auth: AuthService
        ) {
        this.isalertVisiable = false;
        this.InitialSetup();

    }//end 

    ngOnInit() {
        var browserStorage;
        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
                this.user_public_id = localStorage.getItem('userId');


            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
            this.user_public_id = localStorage.getItem('userId');
        }

        browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
        this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
        if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

            this.offsetTimeZone = -5.00;
            this.offsetMinutes = 0;
            this.offsetTimeVal = (this.offsetTimeZone * 3600000) + 720000;
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        }
        else {

            this.offsetTimeZone = browserStorage.getItem('timezone');
            this.offsetMinutes = 30;
            this.offsetTimeVal = (this.offsetTimeZone * 3600000) + 720000;
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;


        }

        this.getcustPsp_accountList();
        this.getcustDebtorList();
    }


    InitialSetup() {

        var currentDate = new Date();
        this.created = currentDate;

        this.paymentprocessForm = this._fbpayprocess.group({
            is_confirmed: new FormControl(""),
            reference: new FormControl("", Validators.required),
            external_id: new FormControl(""),
            public_id: new FormControl(""),
            status: new FormControl(""),
            created: new FormControl(new Date()),

            debtor: this._fbpayprocess.group({
                public_id: new FormControl("Seleccione", Validators.required)
            }),

            user: this._fbpayprocess.group({
                public_id: new FormControl(""),
            }),

            psp_operation: this._fbpayprocess.group({
                external_id: new FormControl(""),
                channel: new FormControl("WEB"),
                method: new FormControl("CASH"),
                processing_date: new FormControl(new Date(currentDate)),
                description: new FormControl(""),
                name: new FormControl("", Validators.required),
                public_id: new FormControl(""),
                customer_account: this._fbpayprocess.group({
                    public_id: new FormControl("Seleccione")
                }),
                psp_account: this._fbpayprocess.group({
                    public_id: new FormControl("Seleccione", Validators.required)
                }),
                total: this._fbpayprocess.group({
                    currency: new FormControl(""),
                    value: new FormControl("")
                })
            }),
            invoice_list: this._fbpayprocess.array([
                ({
                    id: [""],
                    public_id: [""],
                    late_fee: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    }),
                    sub_total: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    }),
                    total: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    })
                })
            ])
        });
    }

    onCreatedChange(_event) {
        this.CreatedDate = _event;
    }


    getcustPsp_accountList() {
        this.customerService.getCustomerBankPspAccountList(this.customer_public_id)
            .subscribe(data => {
                this.cusPsp_accountsList = data;

            });
    }

    getchangecustAccountList(value) {
        this.cusPsp_accountsListNew = this.cusPsp_accountsList.filter(t => t.public_id == value);

        if (this.cusPsp_accountsListNew.length == 0) {
            this.currencysymbol = " ";
        }
        else {
            this.currencysymbol = this.cusPsp_accountsListNew[0].balance.symbol;
            this.dataSourceInvoicesList.filter = '';

            let resources: any;

            this.dataSourceInvoicesList.data = resources;
        }
    }

    getcustDebtorList() {
        this.customerService.getCustomerDebtorsList(this.customer_public_id)
            .subscribe(data => {
                let resources = data["data"];
                this.cusDebtorList = resources;
            });

    }//end



    getcustDebtorAccountList(public_id: string) {

        this.debtorService.getDebtorAccountList(public_id)
            .subscribe(data => {
                this.cusDebtor_accountsList = data;
            });

    }//end

    getcustDebtorInvoiceList(public_id: string) {
        this.invoiceTotalAmt = 0;
        if (public_id != 'Seleccione') {
            this.getcustDebtorAccountList(public_id);
            this.debtorService.getDebtorInvoiceListWithFilters(public_id)
                .subscribe(data => {
                    let resources = data["data"];
                    this.dataSourceInvoicesList.data = resources.filter(d => d.total.symbol == this.currencysymbol);
                    this.dataSourceInvoicesList.filter = '';

                });
        }
        else {
            let resources: any;
            this.dataSourceInvoicesList.data = resources;
        }


    }//end


    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSourceInvoicesList.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        if (this.isAllSelected()) {
            this.selection.clear();
        }
        else {
            this.dataSourceInvoicesList.data.forEach(row => this.selection.select(row));
        }
    }

    selectRow(row) {

        if (this.selection.isSelected(row)) {
            this.selection.toggle(row);
            if (this.invoiceTotalAmt > 0) {
                this.invoiceTotalAmt = this.invoiceTotalAmt - Number(row.total.value);
            }
            else {
                this.invoiceTotalAmt = 0;
            }
        }
        else {
            this.selection.toggle(row);
            this.invoiceTotalAmt = this.invoiceTotalAmt + Number(row.total.value);
            this.selectinvoicelist.push(row);
        }
    }
    viewInvoiceDetails(element) {
        this.dataService.changeinvoicepublicKey(element.public_id);
        const application = localStorage.getItem('application');
        if (AccountTypeOptions[application] != undefined) {
          this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${element.public_id}/view`]);
        }
    }

    onsubmit({ value }: { value: PaymentProcess }) {
        this.buttonValidate = true;
        if (this.invoiceTotalAmt > 0) {
            value.invoice_list = this.selectinvoicelist;
            value.created = this.CreatedDate;
            value.user.public_id = this.user_public_id;

            var momentObj = moment(value.created);
            var createDate = momentObj.format("YYYY-MM-DD HH:mm:ss");

            let createDateGMT = this.convertGMTTime(createDate);

            var momentObjProc = moment(value.psp_operation.processing_date);
            var proceDate = momentObjProc.format("YYYY-MM-DD HH:mm:ss");

            let proceDateGMT = this.convertGMTTime(proceDate);

            value.created = createDateGMT;
            value.psp_operation.processing_date = proceDateGMT;

            value.psp_operation.total.currency = this.cusPsp_accountsListNew[0].balance.currency;
            value.psp_operation.total.value = this.invoiceTotalAmt;
            value.external_id = value.reference;

            value.psp_operation.customer_account.public_id = this.cusDebtor_accountsList[0].public_id;

            if (value.is_confirmed == true) {
                value.is_confirmed = true;
            }
            else {
                value.is_confirmed = false;
            }
            this.paymentProcessService.createPayment(value)
                .subscribe((result) => {
                    this.router.navigate(['/payments']);
                }, error => {
                    console.log('Failed while trying to update the payments Details.' + error);
                });
        }
        else {
            this.statusValue = "Please select the Invoice Amount";
            this.isalertVisiable = true;
        }

    }

    convertGMTTime(startDate1) {
        var dateTimeZoneDiff = startDate1.split(/[- :]/),
            startDateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);

        var startDate2 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
        var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));

        let startDate = moment(startDate3).format('YYYY-MM-DD HH:mm:ss');
        return startDate;
    }
}


